function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery';
import Social from './social/Social';
import Share from './share/Share';
import Texts from './texts/Texts';
import EXTERNAL_INFO_TYPE from '../common/constants/externalInfoType';

var InfoElement = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InfoElement, _React$Component);

  function InfoElement(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      showShare: false
    };
    _this.shouldShowHoverOnMobile = _this.shouldShowHoverOnMobile.bind(_assertThisInitialized(_this));
    _this.shouldHover = _this.shouldHover.bind(_assertThisInitialized(_this));
    _this.isSmallItem = _this.isSmallItem.bind(_assertThisInitialized(_this));
    _this.isNarrow = _this.isNarrow.bind(_assertThisInitialized(_this));
    _this.isShort = _this.isShort.bind(_assertThisInitialized(_this));
    _this.isVerticalContainer = _this.isVerticalContainer.bind(_assertThisInitialized(_this));
    _this.toggleShare = _this.toggleShare.bind(_assertThisInitialized(_this));
    _this.hasRequiredMediaUrl = _this.hasRequiredMediaUrl.bind(_assertThisInitialized(_this));
    _this.getShare = _this.getShare.bind(_assertThisInitialized(_this));
    _this.getSocial = _this.getSocial.bind(_assertThisInitialized(_this));
    _this.getItemTextsDetails = _this.getItemTextsDetails.bind(_assertThisInitialized(_this));
    _this.createHoverInfoElement = _this.createHoverInfoElement.bind(_assertThisInitialized(_this));
    _this.createAboveBelowRightLeftInfoElement = _this.createAboveBelowRightLeftInfoElement.bind(_assertThisInitialized(_this));
    _this.createSlideshowInfoElement = _this.createSlideshowInfoElement.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = InfoElement.prototype;

  _proto.shouldShowHoverOnMobile = function shouldShowHoverOnMobile() {
    var _this$props = this.props,
        isMobile = _this$props.isMobile,
        viewMode = _this$props.viewMode;

    if (isMobile) {
      var _this$props$stylePara = this.props.styleParams,
          allowDescription = _this$props$stylePara.allowDescription,
          allowTitle = _this$props$stylePara.allowTitle,
          titlePlacement = _this$props$stylePara.titlePlacement,
          hoveringBehaviour = _this$props$stylePara.hoveringBehaviour,
          itemClick = _this$props$stylePara.itemClick,
          alwaysShowHover = _this$props$stylePara.alwaysShowHover,
          previewHover = _this$props$stylePara.previewHover;
      var isNewMobileSettings = true; // TODO: featureManager.supports.mobileSettings;

      if (hoveringBehaviour === GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW) {
        return false;
      }

      if (itemClick === 'nothing' && this.props.type !== 'video') {
        return true;
      } else if ((allowTitle || allowDescription) && GALLERY_CONSTS.hasHoverPlacement(titlePlacement) && hoveringBehaviour !== GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW && isNewMobileSettings) {
        return true;
      }

      if (alwaysShowHover) {
        return true;
      }

      if (viewMode === GALLERY_CONSTS.viewMode.EDIT && previewHover) {
        return true;
      }
    }

    return false;
  };

  _proto.shouldHover = function shouldHover() {
    // see if this could be decided in the preset
    var _this$props2 = this.props,
        styleParams = _this$props2.styleParams,
        viewMode = _this$props2.viewMode,
        isMobile = _this$props2.isMobile;

    if (styleParams.hoveringBehaviour === GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW) {
      return false;
    } else if (styleParams.alwaysShowHover === true) {
      return true;
    } else if (viewMode === GALLERY_CONSTS.viewMode.EDIT && styleParams.previewHover) {
      return true;
    } else if (isMobile) {
      return this.shouldShowHoverOnMobile();
    } else {
      return true;
    }
  };

  _proto.isSmallItem = function isSmallItem() {
    var _this$props3 = this.props,
        styleParams = _this$props3.styleParams,
        style = _this$props3.style;

    if (styleParams.isSlideshow) {
      return false;
    }

    var isSmallItem;
    var maxWidth = 90;
    var maxHeight = 90;

    if (styleParams.cubeImages && styleParams.cubeType === 'fit') {
      if (style.orientation === 'landscape') {
        // wide image
        isSmallItem = style.width / style.ratio <= maxHeight;
      } else {
        // tall image
        isSmallItem = style.height * style.ratio <= maxWidth;
      }
    } else {
      isSmallItem = style.width <= maxWidth || style.height <= maxHeight;
    }

    return isSmallItem;
  };

  _proto.isNarrow = function isNarrow() {
    return this.props.style.width < 200;
  };

  _proto.isShort = function isShort() {
    return this.props.style.height < 150;
  };

  _proto.isVerticalContainer = function isVerticalContainer() {
    return this.props.style.width < this.props.style.height + 1;
  };

  _proto.isIconTag = function isIconTag(tagName) {
    return ['button', 'i', 'a', 'svg', 'path'].indexOf(tagName.toLowerCase()) >= 0;
  };

  _proto.toggleShare = function toggleShare(event, forceVal) {
    event.stopPropagation();
    event.preventDefault();

    if (event.type === 'mouseout' && (this.isIconTag(event.target.tagName) || event.relatedTarget && this.isIconTag(event.relatedTarget.tagName))) {
      // mouseout event should not be fired if hovering over icons (tag name === I)
      return;
    }

    this.setState({
      showShare: typeof forceVal === 'undefined' ? !this.state.showShare : !!forceVal
    });
  };

  _proto.hasRequiredMediaUrl = function hasRequiredMediaUrl() {
    var _this$props4 = this.props,
        type = _this$props4.type,
        url = _this$props4.url; // if (there is an url for video items and image items) OR text item (text item do not use media url)

    return url || type === 'text';
  };

  _proto.getShare = function getShare() {
    return /*#__PURE__*/React.createElement(Share, _extends({}, this.props, {
      key: "item-share-" + this.props.id,
      showShare: this.state.showShare,
      isVerticalContainer: this.isVerticalContainer(),
      actions: {
        toggleShare: this.toggleShare,
        eventsListener: this.props.eventsListener
      }
    }));
  };

  _proto.getSocial = function getSocial() {
    return /*#__PURE__*/React.createElement(Social, _extends({}, this.props, {
      showShare: this.state.showShare,
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      isShort: this.isShort(),
      isVerticalContainer: this.isVerticalContainer(),
      key: "item-social-" + this.props.id,
      actions: {
        toggleShare: this.toggleShare,
        getShare: this.getShare,
        eventsListener: this.props.eventsListener
      }
    }));
  };

  _proto.getItemTextsDetails = function getItemTextsDetails(externalTotalInfoHeight) {
    if (externalTotalInfoHeight === void 0) {
      externalTotalInfoHeight = 0;
    }

    var isImage = this.props.type === 'image' || this.props.type === 'picture';
    var useCustomButton = this.props.styleParams.useCustomButton === true;
    var shouldShowButton = (isImage || !this.props.styleParams.isStoreGallery) && useCustomButton;
    return /*#__PURE__*/React.createElement(Texts, _extends({}, this.props, {
      key: "item-texts-" + this.props.id,
      itemContainer: this.props.itemContainer // used in lineHeightFixer
      ,
      infoContainer: this.infoContainer,
      showShare: this.state.showShare,
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      shouldShowButton: shouldShowButton,
      externalTotalInfoHeight: externalTotalInfoHeight,
      actions: {
        eventsListener: this.props.eventsListener
      }
    }));
  };

  _proto.createHoverInfoElement = function createHoverInfoElement() {
    var styleParams = this.props.styleParams;
    var social = this.getSocial();
    var share = this.getShare();
    var itemTexts = GALLERY_CONSTS.hasHoverPlacement(styleParams.titlePlacement) && styleParams.hoveringBehaviour !== GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW ? this.getItemTextsDetails() : null; // if titlePlacement (title & description) is BELOW or ABOVE or RIGHT or LEFT, it is not part of the itemHover

    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "hover-info-element",
      style: {
        height: '100%'
      }
    }, itemTexts, social, share);
  };

  _proto.createSlideshowInfoElement = function createSlideshowInfoElement() {
    var social = this.getSocial();
    var itemTexts = this.getItemTextsDetails();
    var style = {
      height: this.props.styleParams.slideshowInfoSize + "px",
      bottom: "-" + this.props.styleParams.slideshowInfoSize + "px"
    };
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "slideshow-info-element"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gallery-item-info gallery-item-bottom-info",
      "data-hook": "gallery-item-info-buttons",
      style: style
    }, /*#__PURE__*/React.createElement("div", null, social, itemTexts)));
  };

  _proto.createAboveBelowRightLeftInfoElement = function createAboveBelowRightLeftInfoElement() {
    var _this$props5 = this.props,
        styleParams = _this$props5.styleParams,
        style = _this$props5.style; // if there is no url for videos and images, we will not render the itemWrapper
    // but will render the info element if exists, with the whole size of the item

    var infoHeight = styleParams.textBoxHeight + (this.hasRequiredMediaUrl() ? 0 : style.height);
    var itemTexts = this.getItemTextsDetails(infoHeight);
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "external-info-element"
    }, itemTexts);
  };

  _proto.render = function render() {
    var _this2 = this;

    var infoType = this.props.infoType;
    var infoElement;

    switch (infoType) {
      case EXTERNAL_INFO_TYPE.SLIDESHOW:
        infoElement = this.createSlideshowInfoElement();
        break;

      case EXTERNAL_INFO_TYPE.EXTERNAL:
        infoElement = this.createAboveBelowRightLeftInfoElement();
        break;

      case EXTERNAL_INFO_TYPE.HOVER:
        infoElement = this.createHoverInfoElement();
        break;

      default:
        console.warn('InfoElement -> EXTERNAL_INFO_TYPE was not selected');
    }

    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "info-element",
      ref: function ref(e) {
        return _this2.infoContainer = e;
      },
      style: {
        height: '100%'
      }
    }, infoElement);
  };

  return InfoElement;
}(React.Component);

export { InfoElement as default };